<template lang="html">
  <div class="blockly"></div>
</template>

<script>
const UtilFiles = window.UtilFiles;
const Blockly = window.Blockly;

export default {
  props: ['fileData'],
  methods: {
    changeFileData: function (xml, js) {
      this.fileData.data = {
    		xml: xml,
    		js: js
    	};
    }
  },
  mounted: function () {
    var blockly = this.$el;
  	UtilFiles.getFile('assets/libs/google-blockly/toolbox.xml').then((toolbox) => {
  		var workspace = Blockly.inject(blockly, {
  			// media: 'google-blockly/media/',
  			toolbox: toolbox
  		});
  		if (this.fileData.data.xml) {
  			var xml = Blockly.Xml.textToDom(this.fileData.data.xml);
  			Blockly.Xml.domToWorkspace(xml, workspace);
  		}
  		workspace.addChangeListener((event) => {
        console.log('blockly-workspace-change', event);
  			var xml = Blockly.Xml.workspaceToDom(workspace);
  			var text = Blockly.Xml.domToText(xml);
  			var code = Blockly.JavaScript.workspaceToCode(workspace);
  			this.changeFileData(text, code);
  		});
  		var onresize = function() {
  			Blockly.svgResize(workspace);
  		};
  		window.addEventListener('resize', onresize, false);
  		document.addEventListener('changetreeview', onresize, false);
  		onresize();
  	});
  },
  beforeUnmount: function () {
    console.log('Destroy');
  }
}
</script>

<style lang="css">
.blockly {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 0;
}
.blocklySvg {
	background: none;
}
.blocklyToolboxDiv {
	background-color: #1c2428;
}
.blocklyFlyoutBackground {
	fill: #313a3e;
}
.blocklyMainBackground {
	stroke: none;
}
.blocklyTreeSeparator {
	border-color: rgba(255, 255, 255, 0.1) !important;
}
.blocklyTreeRow:not(.blocklyTreeSelected):hover {
	background-color: rgba(255, 255, 255, 0.1);
}
</style>
